<template>
  <div class="sidebar-container">
   <!-- 这里时rout： {{ this.$route.path }} -->
    <el-scrollbar class="theme" wrap-class="scrollbar-wrapper">
<!--
        :background-color="sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"
        :text-color="sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"
        :active-text-color="theme"
        :default-active="activeMenu"
        :collapse="isCollapse"
        style="background-color: #ffffff"
        -->

      <!-- <el-menu
        :unique-opened="true"
        background-color="#ffffff"
        :collapse-transition="false"
        :collapse="false"
        mode="vertical"
        :default-active="$route.path"
        @select="selectMenu"
      > -->
      <el-menu
        :unique-opened="true"
        background-color="#ffffff"
        :collapse-transition="false"
        :collapse="false"
        mode="vertical"
        :default-active="$route.path"
      >
        <SidebarItem 
          v-for="(route, index) in sidebarRouters"
          :key="index + Math.random()*10 + Math.random()*10"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>

  </div>
</template>

<script>
import SidebarItem from './sidebar-item.vue'
import Cookies from 'js-cookie'
export default {
  components: {
    SidebarItem
  },
  data() {
    return {
      // activeMenu: '/index',
      sidebarRouters:[
        // {
        //   "name": "index",
        //   "path": "/index",
        //   "hidden": false,
        //   "ficon":'../../../static/img/icon/daohanglan/首页1.svg',
        //   "icon":"../../../static/img/icon/daohanglan/首页2.svg",
        //   "meta": {
        //     "title": "首页",
        //     "icon": "user",
        //   }
        // },
        {
          "name": "ocpc",
          "path": "/ocpc",
          "hidden": !this.$store.getters.ocpcCustomer&&!this.$store.getters.ocpcSupplier&&!this.$store.getters.ocpcGetPhoneUp
                  &&!this.$store.getters.ocpcTaxBill&&!this.$store.getters.apiCompanyId,
          "ficon":'../../../static/img/icon/daohanglan/ocpc云1.svg',
          "icon":"../../../static/img/icon/daohanglan/ocpc云2.svg",
          "alwaysShow": true,
          "meta": {
            "title": "OCPC云",
            "icon": "system",
          },
          "children": [
            {
              "name": "dataDownload",
              "path": "dataDownload",
              "hidden": !this.$store.getters.ocpcCustomer,
              "meta": {
                "title": "模型获客",
                "icon": "user",
              }
            },
            {
              "name": "dataUpload",
              "path": "dataUpload",
              "hidden": !this.$store.getters.ocpcSupplier,
              "meta": {
                "title": "数据上传",
                "icon": "user",
              }
            },
            {
              "name": "busPhoneUpload",
              "path": "busPhoneUpload",
              "hidden": !this.$store.getters.ocpcGetPhoneUp,
              "meta": {
                "title": "工商联系人",
                "icon": "user",
              }
            },
            {
              "name": "taxBill",
              "path": "taxBill",
              "hidden": !this.$store.getters.ocpcTaxBill,
              "meta": {
                "title": "税票查询",
                "icon": "user",
              }
            },
            {
              "name": "apiBill",
              "path": "apiBill",
              "hidden": !this.$store.getters.apiCompanyId,
              "meta": {
                "title": "接口账单",
                "icon": "user",
              }
            },
            // {
            //   "name": "similarRecommend",
            //   "path": "similarRecommend",
            //   "hidden": false,
            //   "meta": {
            //     "title": "模型拓客",
            //     "icon": "user",
            //   }
            // },
            // {
            //   "name": "guessYouLike",
            //   "path": "guessYouLike",
            //   "hidden": false,
            //   "meta": {
            //     "title": "潜客推荐",
            //     "icon": "tree-table",
            //   }
            // },
            // {
            //   "name": "advancedSearch",
            //   "path": "advancedSearch",
            //   "hidden": false,
            //   "meta": {
            //     "title": "高级搜索",
            //     "icon": "peoples",
            //   }
            // },
            // {
            //   "name": "batchQuery",
            //   "path": "batchQuery",
            //   "hidden": false,
            //   "meta": {
            //     "title": "批量补全",
            //     "icon": "tree",
            //   }
            // },
            // {
            //   "name": "map",
            //   "path": "map",
            //   "hidden": false,
            //   "meta": {
            //     "title": "地图拓客",
            //     "icon": "tree",
            //   }
            // }
          ]
        },
        // {
        //   "name": "osint",
        //   "path": "/osint",
        //   "hidden": false,
        //   "ficon":'../../../static/img/icon/daohanglan/osint云1.svg',
        //   "icon":"../../../static/img/icon/daohanglan/osint云2.svg",
        //   "redirect": "noRedirect",
        //   "alwaysShow": true,
        //   "meta": {
        //     "title": "OSINT云",
        //     "icon": "monitor",
        //   },
        //   "children": [
        //     {
        //       "name": "customerProfile",
        //       "path": "customerProfile",
        //       "hidden": false,
        //       "meta": {
        //         "title": "舆情监控",
        //         "icon": "online",
        //       }
        //     },
        //     // {
        //     //   "name": "enterpriseMap",
        //     //   "path": "enterpriseMap",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "招投标",
        //     //     "icon": "job",
        //     //   }
        //     // },
        //     {
        //       "name": "KPdataCustomized",
        //       "path": "KPdataCustomized",
        //       "hidden": false,
        //       "meta": {
        //         "title": "人企关系图谱",
        //         "icon": "druid",
        //       }
        //     },
        //     // {
        //     //   "name": "corporateInformation",
        //     //   "path": "corporateInformation",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "企业资讯",
        //     //     "icon": "server",
        //     //   }
        //     // }
        //   ]
        // },
        // {
        //   "name": "resource",
        //   "path": "/resource",
        //   "hidden": false,
        //   "ficon":'../../../static/img/icon/daohanglan/客户资源1.svg',
        //   "icon":"../../../static/img/icon/daohanglan/客户资源2.svg",
        //   "redirect": "noRedirect",
        //   "alwaysShow": true,
        //   "meta": {
        //     "title": "客户资源",
        //     "icon": "tool",
        //   },
        //   "children": [
        //     {
        //       "name": "crowdPack",
        //       "path": "crowdPack",
        //       "hidden": false,
        //       "meta": {
        //         "title": "人群包",
        //         "icon": "build",
        //       }
        //     },
        //     {
        //       "name": "customerPool",
        //       "path": "customerPool",
        //       "hidden": false,
        //       "meta": {
        //         "title": "客户池",
        //         "icon": "code",
        //       }
        //     }
        //   ]
        // },
        // {
        //   "name": "aigc",
        //   "path": "/aigc",
        //   "hidden": false,
        //   "ficon":'../../../static/img/icon/daohanglan/aigc云1.svg',
        //   "icon":"../../../static/img/icon/daohanglan/aigc云2.svg",
        //   "redirect": "noRedirect",
        //   "alwaysShow": true,
        //   "meta": {
        //     "title": "AIGC云",
        //     "icon": "tool",
        //   },
        //   "children": [
        //     // {
        //     //   "name": "AIGC4",
        //     //   "path": "http://www.jiguangcloud.com/aig",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "AIGC云",
        //     //     "icon": "build",
        //     //   }
        //     // },
        //     // {
        //     //   "name": "textGeneration",
        //     //   "path": "textGeneration",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "文本生成",
        //     //     "icon": "build",
        //     //   }
        //     // },
        //     {
        //       "name": "imageGeneration",
        //       "path": "imageGeneration",
        //       "hidden": false,
        //       "meta": {
        //         "title": "图片生成",
        //         "icon": "build",
        //       }
        //     },
        //     // {
        //     //   "name": "AIGC7",
        //     //   "path": "videoGeneration",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "视频生成",
        //     //     "icon": "build",
        //     //   }
        //     // },
        //     {
        //       "name": "textRecognize",
        //       "path": "textRecognize",
        //       "hidden": false,
        //       "meta": {
        //         "title": "文字识别",
        //         "icon": "build",
        //       }
        //     },
        //     // {
        //     //   "name": "imageTextConversion",
        //     //   "path": "imageTextConversion",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "文本互转",
        //     //     "icon": "build",
        //     //   }
        //     // },
        //     // {
        //     //   "name": "audioProcessing",
        //     //   "path": "audioProcessing",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "音频处理",
        //     //     "icon": "build",
        //     //   }
        //     // }
        //   ]
        // },
        // {
        //   "name": "crm",
        //   "path": "/crm",
        //   "hidden": false,
        //   "ficon":'../../../static/img/icon/daohanglan/crm云1.svg',
        //   "icon":"../../../static/img/icon/daohanglan/crm云2.svg",
        //   "meta": {
        //     "title": "CRM云",
        //     "icon": "user",
        //   },
          
        // },
        // {
        //   "name": "marketing",
        //   "path": "/marketing",
        //   "hidden": false,
        //   "ficon":'../../../static/img/icon/daohanglan/营销云1.svg',
        //   "icon":"../../../static/img/icon/daohanglan/营销云2.svg",
        //   "redirect": "noRedirect",
        //   "alwaysShow": true,
        //   "meta": {
        //     "title": "营销云",
        //     "icon": "tool",
        //   },
        //   "children": [
        //     {
        //       "name": "taskList",
        //       "path": "taskList",
        //       "hidden": false,
        //       "meta": {
        //         "title": "任务列表",
        //         "icon": "build",
        //       }
        //     },
        //     {
        //       "name": "massMailing",
        //       "path": "massMailing",
        //       "hidden": false,
        //       "meta": {
        //         "title": "邮件",
        //         "icon": "build",
        //       }
        //     },
        //     {
        //       "name": "AIOutboundCall",
        //       "path": "AIOutboundCall",
        //       "hidden": false,
        //       "meta": {
        //         "title": "外呼",
        //         "icon": "build",
        //       },
        //       "children": [
        //         {
        //           "name": "RecordingInspection",
        //           "path": "RecordingInspection",
        //           "hidden": false,
        //           "meta": {
        //             "title": "录音质检",
        //             "icon": "build",
        //           }
        //         },
        //         {
        //           "name": "CustomerCallList",
        //           "path": "CustomerCallList",
        //           "hidden": false,
        //           "meta": {
        //             "title": "客户话单",
        //             "icon": "build",
        //           }
        //         },
        //         {
        //           "name": "AgentReport",
        //           "path": "AgentReport",
        //           "hidden": false,
        //           "meta": {
        //             "title": "坐席报表",
        //             "icon": "build",
        //           }
        //         }
        //       ]
        //     },
        //      {
        //       "name": "SMS",
        //       "path": "SMS",
        //       "hidden": false,
        //       "meta": {
        //         "title": "国内短信",
        //         "icon": "build",
        //       }
        //     },
        //     // {
        //     //   "name": "SMS2",
        //     //   "path": "SMS2",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "国际短信",
        //     //     "icon": "build",
        //     //   }
        //     // },

        //     // {
        //     //   "name": "marketing",
        //     //   "path": "marketing",
        //     //   "hidden": false,
        //     //   "meta": {
        //     //     "title": "营销推广",
        //     //     "icon": "build",
        //     //   }
        //     // },
        //   ]
        // }
      ],
    }
  },
  mounted() {
    this.getMenu()
  },
  methods: {
    getMenu(){
      // if(this.$store.getters.showCRM) {
      //   this.sidebarRouters[5].children = [
      //       {
      //         "name": "highSeasPool/highSeasPool",
      //         "path": "highSeasPool/highSeasPool",
      //         "hidden": false,
      //         "meta": {
      //           "title": "公海池",
      //           "icon": "build",
      //         }
      //       },
      //       {
      //         "name": "clue/unallocatedClue",
      //         "path": "clue/unallocatedClue",
      //         "hidden": false,
      //         "meta": {
      //           "title": "待分配线索",
      //           "icon": "build",
      //         }
      //       },
      //       {
      //         "name": "clue/clueManage",
      //         "path": "clue/clueManage",
      //         "hidden": false,
      //         "meta": {
      //           "title": "线索管理",
      //           "icon": "build",
      //         }
      //       },
      //       {
      //         "name": "businessManage/businessManage",
      //         "path": "businessManage/businessManage",
      //         "hidden": false,
      //         "meta": {
      //           "title": "商机管理",
      //           "icon": "build",
      //         }
      //       },
      //       {
      //         "name": "contractManage/contractManage",
      //         "path": "contractManage/contractManage",
      //         "hidden": false,
      //         "meta": {
      //           "title": "合同管理",
      //           "icon": "build",
      //         }
      //       },
      //       {
      //         "name": "custGroup/custGroup",
      //         "path": "custGroup/custGroup",
      //         "hidden": false,
      //         "meta": {
      //           "title": "客户分组",
      //           "icon": "build",
      //         }
      //       },
      //       {
      //         "name": "organizatio",
      //         "path": "/organizatio",
      //         "hidden": !this.$store.getters.crmAdmin,
      //         "meta": {
      //           "title": "组织架构",
      //           "icon": "build",
      //         },
      //         "children": [
      //           {
      //             "name": "userManage",
      //             "path": "/crm/organizatio/userManage",
      //             "hidden": false,
      //             "meta": {
      //               "title": "用户管理",
      //               "icon": "build",
      //             },
      //           },
      //           {
      //             "name": "deptManage",
      //             "path": "/crm/organizatio/deptManage",
      //             "hidden": false,
      //             "meta": {
      //               "title": "部门管理",
      //               "icon": "build",
      //             },
      //           },
      //         ]
      //       },
      //       {
      //         "name": "fieldSet/fieldSetList",
      //         "path": "fieldSet/fieldSetList",
      //         "hidden": !this.$store.getters.crmAdmin,
      //         "meta": {
      //           "title": "字段设置",
      //           "icon": "build",
      //         }
      //       },
      //   ]
      //     this.$forceUpdate()
      // }
    },
  },
}
</script>

<style lang="less">
.sidebar-container {
  //width: 146px !important;
  .el-menu-item.is-active{
    //设置背景颜色
    background-color: rgba(79, 177, 246, 0.3) !important;
    border-left: #1E56FE 5px solid;
    //设置字体颜色
    color: #1E56FE !important;
  }
  .el-submenu__title:hover, .el-menu-item:hover{
    //设置背景颜色
    background-color: rgba(79, 177, 246, 0.3) !important;
    //设置字体颜色
    color: #1E56FE !important;
  }

  .theme .is-active > .el-sub-menu__title {
    color: #4FB1F6 !important;
  }

  .theme {
    height: calc(100vh - 60px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/sidebar.vue